import { render } from "./WebchatTab.vue?vue&type=template&id=fadc1750&scoped=true&lang=pug"
import script from "./WebchatTab.js?vue&type=script&lang=js&external"
export * from "./WebchatTab.js?vue&type=script&lang=js&external"

import "./WebchatTab.vue?vue&type=style&index=0&id=fadc1750&lang=scss&scoped=true"
import "./WebchatTab.vue?vue&type=style&index=1&id=fadc1750&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fadc1750"]])

export default __exports__